var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-day",class:{
    'calendar-no-regos': !_vm.hasRegos,
    'calendar-has-regos': _vm.hasRegos && _vm.day.isCurrentMonth,
    'calendar-day--not-current': !_vm.day.isCurrentMonth
  },on:{"click":function($event){return _vm.clickDay(_vm.day.date)}}},[(_vm.day.isCurrentMonth)?_c('span',{class:{ }},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }